import initTableScroll from './table_init'

$(document).on('ready turbolinks:load', () => {
  initTableScroll();
});
